import { Box, Tooltip } from "@mui/material";
import { zhTW } from "@mui/x-data-grid";
import Label from "../../libs/rhf-mui/ui/Label";
import { SxProps, Theme } from "@mui/material"



export class UIHelper {
  static render_Content(title: string, demo_text_loop: number) {
    return <>
      <Box sx={{ my: 2 }}>
        <Label>
          {[...new Array(demo_text_loop)]
            .map(
              () => `[${title}] Cras mattis consectetur purus sit amet fermentum.
              Cras justo odio, dapibus ac facilisis in, egestas eget quam.
              Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
              Praesent commodo cursus magna, vel scelerisque nisl consectetur et.`
            )
            .join('\n\n')}
        </Label>

      </Box>

    </>;
  }
}


export const DGV_LOCAL_TEXT = {
  ...zhTW.components.MuiDataGrid.defaultProps.localeText,
  toolbarColumns: "欄位",
  toolbarFilters: "篩選",
  toolbarDensity: "間距",
  toolbarExport: "匯出"
}// 中文



export const sx_icon_button: SxProps<Theme> | undefined = {
  mr: 0,
  py: 1,
  /* gpt: 方形的 Hover */
  borderRadius: '4px',
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
}

export function render_ToolTipCell() {
  return (params: any) => (
    <Tooltip title={params.value}>
      <span>{params.value}</span>
    </Tooltip>
  )
}